// @flow
/**
 * User: Mike Chung
 * Date: 18/1/2018
 * Time: 9:54 PM
 */

type SsoStatus = "active" | "inactive" | "disabled"

class SsoUser {

    ssoUid: string;
    firstName: string;
    lastName: string;
    email: string;
    createDate: string;
    lastModifiedDate: string;
    status: SsoStatus;
    companyName: ?string;
    countrySid: ?number;
    countryCode: ?string;

    constructor(ssoUid: string, email: string, firstName: string, lastName: string, status: 1 | 2 | 3, createDate: string, lastModifiedDate: string, companyName: ?string, countrySid: ?number, countryCode: ?string) {
        this.ssoUid = ssoUid;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.createDate = createDate;
        this.lastModifiedDate = lastModifiedDate;
        switch (status) {
            case 1:
                this.status = "active";
                break;
            case 2:
                this.status = "inactive";
                break;
            case 3:
                this.status = "disabled";
                break;
            default:
                this.status = "disabled";
                break;
        }
        this.companyName = companyName;
        this.countrySid = countrySid;
        this.countryCode = countryCode;
    }
}

export default SsoUser;


// WEBPACK FOOTER //
// ./src/model/sso/SsoUser.js